import { User, Clock } from "lucide-react";
import { Card, CardContent } from "./ui/card";
import { siteData } from "../data/mock";

export const DoctorSection = () => {
  const { doctor } = siteData;

  return (
    <section
      id="doctor"
      aria-labelledby="doctor-heading"
      className="py-20 lg:py-28"
      style={{ background: "#F8F8F8" }}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Doctor Image */}
          <div className="relative">
            <Card className="overflow-hidden rounded-2xl shadow-lg border-0 bg-gradient-to-br from-stone-100 to-stone-200">
              <div className="relative aspect-[6/5] max-h-[650px]">
                <img
                  src={doctor.image}
                  alt={`${doctor.name} - Licensed Acupuncturist`}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#232323]/90 via-[#232323]/50 to-transparent p-6">
                  <h3
                    className="text-2xl font-semibold text-white mb-1"
                    style={{ fontFamily: '"Cormorant Garamond", serif' }}
                  >
                    {doctor.name}
                  </h3>
                  <p className="text-stone-300 text-sm">{doctor.title}</p>
                </div>
              </div>
            </Card>
          </div>

          {/* Doctor Info */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <User className="w-4 h-4 text-stone-500" aria-hidden="true" />
              <span className="text-sm text-stone-500 font-medium">
                Meet the Specialist
              </span>
            </div>

            <h2
              id="doctor-heading"
              className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#232323] mb-5 tracking-tight"
              style={{ fontFamily: '"Cormorant Garamond", serif' }}
            >
              Meet Dr. Kang
            </h2>

            <p className="text-lg text-stone-500 leading-relaxed mb-8">
              {doctor.bio}
            </p>

            {/* Credentials Cards */}
            <div className="space-y-4 mb-8">
              <Card className="border border-stone-100 shadow-sm rounded-xl bg-white">
                <CardContent className="p-5 flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-stone-50 flex items-center justify-center shrink-0">
                    <User className="w-5 h-5 text-stone-600" aria-hidden="true" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#232323] mb-1">
                      Credentials
                    </h4>
                    <p className="text-sm text-stone-500 leading-relaxed">
                      {doctor.highlights[0].description}
                    </p>
                  </div>
                </CardContent>
              </Card>

              <Card className="border border-stone-100 shadow-sm rounded-xl bg-white">
                <CardContent className="p-5 flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-stone-50 flex items-center justify-center shrink-0">
                    <Clock className="w-5 h-5 text-stone-600" aria-hidden="true" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#232323] mb-1">
                      Experience
                    </h4>
                    <p className="text-sm text-stone-500 leading-relaxed">
                      10+ years of clinical experience since 2006, treating over 2,000 patients.
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-4">
              {doctor.stats.map((stat) => (
                <Card
                  key={stat.label}
                  className="border border-stone-100 shadow-sm rounded-xl bg-white text-center"
                >
                  <CardContent className="p-5">
                    <div
                      className="text-3xl lg:text-4xl font-bold text-[#232323] mb-1"
                      style={{ fontFamily: '"Cormorant Garamond", serif' }}
                    >
                      {stat.value}
                    </div>
                    <div className="text-xs text-stone-500 font-medium">
                      {stat.label}
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
